import type { Locale } from '@/types/dictionary';

export const NEXT_LOCALE = 'NEXT_LOCALE';
export const DEFAULT_LOCALE: Locale = 'en';
export const LOCALES: Locale[] = ['en', 'nl', 'fr', 'de', 'es'];
export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  nl: 'Nederlands',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
};
export const LOCALE_LABELS: Record<Locale, string> = {
  nl: 'NL',
  fr: 'FR',
  de: 'DE',
  en: 'EN',
  es: 'ES',
};

export const LOCALE_EMOJIS: Record<Locale, string> = {
  nl: '🇳🇱',
  fr: '🇫🇷',
  de: '🇩🇪',
  en: '🇬🇧',
  es: '🇪🇸',
};
